$bog_gamengine_demo_boxes $mol_page
	title \Ящики
	tools /
		<= Count $mol_number
			value? <=> count? 300
			value_min 1
		<= Reset $mol_button_minor
			title \Сброс
			click? <=> reset? null
		<= Chain $mol_button_minor
			title \Цепь
			click? <=> chain? null
		<= Door $mol_button_minor
			title \Дверь
			click? <=> door? null
		<= Wireframe $mol_check_box
			title \Каркас
			checked? <=> wireframe?
		<= Contacts $mol_check_box
			title \Контакты
			checked? <=> contacts? false
		<= Pause $mol_check_box
			title \Пауза
			checked? <=> paused?
	body /
		<= Draw $bog_gamengine_draw
			scene <= Scene
			cam <= Walker
			wireframe? => wireframe?
			stat => stat
			event *
				pointerdown? <=> shoot? null
				contextmenu? <=> dig? null
	foot /
		<= Stat $mol_view
			sub / <= stat
		<= Phys_stat $mol_view
			sub / <= phys_stat \
		<= Cull_stat $mol_view
			sub / <= cull_stat \
	seed? 1
	Input $bog_gamengine_input
		key <= Key
	Key $bog_gamengine_key
		bind *
			forward / \W
			back / \S
			left / \A
			right / \D
			turn_left / \Q
			turn_right / \E
	Atlas $bog_gamengine_atlas
		uris /
			\bog/gamengine/demo/atlas/wall.png
			\bog/gamengine/demo/atlas/floor.png
		size 64
	Clock $bog_gamengine_clock
		paused? => paused?
	Phys $bog_gamengine_demo_boxes_phys
	Scene $bog_gamengine_scene
		clock <= Clock
		input <= Input
		kids <= nodes /
		phys3 <= Phys
		batches <= batches /
		cam <= Walker
		aspect <= aspect 1
		Shader_solid <= Solid
	Crates $bog_gamengine_batch
		shader <= Solid $bog_gamengine_shader_solid
		shape <= Box $bog_gamengine_shape_box
		atlas <= Atlas
		source <= Phys
		skip 1
	Contact_batch $bog_gamengine_batch
		shader <= Flat $bog_gamengine_shader_flat
		shape <= Lines $bog_gamengine_shape_lines
			points <= contact_points Float32Array
			count <= contact_count 0
		instances 1
	Debug $bog_gamengine_phys3_debug
		phys3 <= Phys
	Floor $bog_gamengine_mesh
		shape <= Plane $bog_gamengine_shape_plane
			tile <= floor_tile Float32Array
		atlas <= Atlas
		frame \floor
		size <= floor_size Float32Array
	Thrown* $bog_gamengine_phys3_body
		name \Брошенный
	Platform* $bog_gamengine_demo_boxes_platform
		name \Платформа
		phys3 <= Phys
		size <= platform_size Float32Array
		mass 0
		kinematic true
	Walker $bog_gamengine_demo_room_walker
		input <= Input
		pos? <=> walker_pos? Float32Array
		rot? <=> walker_rot? Float32Array
